 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		214: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"6962ae5","1":"99cfb3c","2":"e10c5f8","3":"35fb6ae","4":"beb7ecc","5":"209a438","6":"f2c99ca","7":"301c5d6","8":"9af19d0","9":"dc28261","10":"165a62b","11":"f1a933b","12":"dbed651","13":"6f9d569","14":"46a2e7a","15":"f85fdf6","16":"b2d4966","17":"26fc4c0","18":"1707f4f","19":"5603634","20":"50528c2","21":"5cb3d3a","22":"4c4fe70","23":"00637d9","24":"1398407","25":"8ec68a5","26":"2a121bd","27":"228c943","28":"4b067a0","29":"87eccb4","30":"d1a48f0","31":"d33116e","32":"680c7ad","33":"d25920e","34":"bd63ee4","35":"eeda946","36":"6538bf1","37":"b98487f","38":"572aab9","39":"0b89c39","40":"8d0b686","41":"a62cf47","42":"5252793","43":"5fb963a","44":"d3d4eaa","45":"ae88cb6","46":"4edb19a","47":"430e717","48":"52235ff","49":"f96dcbb","50":"83e5207","51":"62a39e8","52":"4bdd514","53":"588d909","54":"9e7ca69","55":"e26cf24","56":"4bbe1f8","57":"f943d5c","58":"b81e27d","59":"6108f76","60":"1456ae7","61":"f2fb510","62":"c56eb56","63":"d6803b6","64":"1ce2db5","65":"3d4b3a2","66":"ad4102a","67":"d893673","68":"fbf95db","69":"9ae15ad","70":"b19170a","71":"7bfafec","72":"aacada6","73":"8334395","74":"58fd215","75":"4437251","76":"3df1973","77":"74dea8e","78":"b77ddd4","79":"b71d1eb","80":"2c966c9","81":"63d029e","82":"f2542eb","83":"2ae1973","84":"9df7063","85":"40a4df5","86":"2556948","87":"9dfc06f","88":"7367aec","89":"49f4ebe","90":"b5fa059","91":"c4f03c8","92":"4b234de","93":"49bb08c","94":"21d8453","95":"66219a9","96":"b4566be","97":"c4234f4","98":"5bc4805","99":"27c323e","100":"85d5c0a","101":"3426434","102":"ae2d140","103":"bc0036e","104":"1692fff","105":"de8e517","106":"af7d3db","107":"9793e2f","110":"67b1a6d","111":"68b1efa","112":"e3b3187","113":"941993b","114":"a0d3500","115":"da89ba7","116":"9663e5d","117":"d69b230","118":"fabac63","119":"56eb4cf","120":"5a1d716","121":"80e01ee","122":"ef1fe8d","123":"3bfb83a","124":"ab94424","125":"4e2e37c","126":"9ff4536","127":"0af7700","128":"07aac19","129":"96712c7","130":"c38b989","131":"09a371f","132":"52c86c1","133":"fbbe680","134":"007d4a9","135":"aaba45f","136":"c0f7738","137":"9ffe40c","138":"73c87dd","139":"224e394","140":"d7385e1","141":"c7767ff","142":"4465f64","143":"a60e19f","144":"e5dfae0","145":"45f44f4","146":"5c398e2","147":"f94b872","148":"53c7b89","149":"1805ddb","150":"2abeaad","151":"472296f","152":"33bdfde","153":"1085487","154":"d27d998","155":"0c68385","156":"2e2b0aa","157":"c0a64c1","158":"864c3b0","159":"d9525df","160":"55ae167","161":"3b6a602","162":"14eb3d5","163":"8d26cce","164":"7301bc7","165":"4dda667","166":"87a2eb8","167":"3320fde","168":"a3f84e9","169":"628c482","170":"96f335d","171":"2d75a99","172":"7c0f8c7","173":"d713fc7","174":"d25c87a","175":"2205e3c","176":"de42f61","177":"0047c78","178":"7a5c287","179":"592da9a","180":"2f82dd4","181":"f97acab","182":"963d492","183":"5cfdb3c","184":"9f1a535","185":"447ccaf","186":"f9c82d4","187":"33200bb","188":"74d7400","189":"25c975c","190":"b1cd039","191":"c593243","192":"a5578b1","193":"5e97ba6","194":"2d82712","195":"1bdb17e","196":"55f7a2d","197":"b38d570","198":"7f5ea95","199":"e0eef38","200":"d2cefc6","201":"d4fe5a9","202":"ee4ab23","203":"e22e811","204":"48dc5c8","205":"f560e54","206":"8f08b14","207":"300375e","208":"a9f2d78","209":"4abf27d","210":"c87032c","211":"f507530","212":"fd754b9","213":"5e3b830","216":"41c150c","217":"392fdb7","218":"76efc05","219":"6d3afaf","220":"9dd8ca9","221":"a97ad2d","222":"68cade8","223":"5d9fb55","224":"a047331","225":"ba6ea78","226":"c6c3573","227":"df8d08a","228":"433bac2","229":"64aa28b","230":"98e48c3","231":"1badc6d","232":"af51029","233":"09ce660","234":"709bd64","235":"b35e84a","236":"0532cf7","237":"2391962","238":"07c5f18","239":"9814d07","240":"3bfd36b","241":"845d411","242":"3b98db6","243":"ade1845","244":"2a47c6b","245":"8e9f118","246":"737bba1","247":"155897a","248":"740aa67","249":"f85c147","250":"8730ddd","251":"b42de10","252":"8118c1c","253":"cb3b9b5","254":"d79b695","255":"b5f6f9c","256":"ccef57c","257":"a91e577","258":"fe1eb81","259":"f2f880a","260":"f52ffa0","261":"394603a","262":"6b928ab","263":"6d8c65d","264":"f301de6","265":"b3be3e7","266":"e7ce356","267":"418390c","268":"49fd6da","269":"dc61bdb","270":"852455a","271":"92d0b74","272":"5efb732","273":"0b0f868","274":"2e7f089","275":"13efc48","276":"b619642","277":"1e4650f","278":"f6d5666","279":"493bb5c","280":"73b8b36","281":"0ca1a34","282":"498c31f","283":"72b714b","284":"49e7b01","285":"26a7ea3","286":"9febe0d","287":"83ef074","288":"2edd493","289":"445bd09","290":"fffd12b","291":"42708a9","292":"6360ef2","293":"cda212b","294":"ff90410","295":"c36ac43","296":"0a29bdb","297":"7d262b2","298":"9eba399","299":"12b43ec","300":"d023510","301":"2e2c771","302":"820391f","303":"4fe0445","304":"65e90e2","305":"2039d9f","306":"c4cb8d4","307":"37e91d8","308":"44b37ef","309":"2badb9b","310":"6aa8c5f","311":"de4bb07","312":"608cfd4","313":"b37ae0c","314":"b987ab8","315":"1bc9da8","316":"5c156f5","317":"831adc5","318":"f2ffeb7","319":"8a54ff4","320":"170ee78","321":"1bb9d6d","322":"5a5c4c5","323":"3345b65","324":"9ead10c","325":"929021b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d1mf56q6wc1y19.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
